export default __webpack_public_path__ + "static/media/president.52118577.png";